// import this after install `@mdi/font` package
import '@mdi/font/css/materialdesignicons.css';
import { mdi } from 'vuetify/iconsets/mdi';
import * as heroSolid from '@heroicons/vue/solid';
import * as heroOutline from '@heroicons/vue/outline';

import { createVuetify } from 'vuetify';
import 'vuetify/styles';

export default defineNuxtPlugin((app) => {
  const vuetify = createVuetify({
    display: {
      thresholds: {
        xs: 0,
        sm: 390,
        md: 768,
        lg: 1280,
        xl: 1590,
      },
    },
    icons: {
      defaultSet: 'mdi',
      sets: {
        mdi,
        heroSolid: {
          component: (props) => h(heroSolid[props.icon]),
        },
        heroOutline: {
          component: (props) => h(heroOutline[props.icon]),
        },
      },
    },
  });
  app.vueApp.use(vuetify);
});
